export const SelectArrowIcon = ({ color = "#DBBE78", size = 10, ...props }) => (
    <svg
        width={size}
        height={size * (7 / 10)}
        viewBox="0 0 10 7"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path d="M10 0.503909L4.99548 6.50011L4.44237e-05 0.496312L10 0.503909Z" fill={color} />
    </svg>
);
